import { IS_PRERENDERING } from '@/init/settings.ts'

export function productsPilotForm() {
  if (IS_PRERENDERING) {
    return
  }
  const apiBaseURL = 'https://www.shortform.com/api/'
  const surveyURLs = {
    digest: {
      yes: 'https://tally.so/r/wozdEb',
      no: 'https://tally.so/r/nGbD6e',
    },
    extension: {
      yes: 'https://tally.so/r/mV9RyE',
      no: 'https://tally.so/r/mD0kqZ',
    },
    webclipper: {
      yes: 'https://tally.so/r/mKGLqz',
      no: 'https://tally.so/r/wvz4QX',
    },
  }

  const request = {
    post(apiUrl, data) {
      return new Promise((resolve, reject) => {
        const url = `${apiBaseURL}${apiUrl}`
        const requestConfig = {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Accept-Encoding': 'gzip, deflate',
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'X-Sf-Client': '11.8.0',
            'Sec-Fetch-Dest': 'empty',
            'Sec-Fetch-Mode': 'cors',
            'Sec-Fetch-Site': 'cross-site',
          },
          referrerPolicy: 'no-referrer',
          body: data,
        }
        fetch(url, requestConfig)
          .then((response) => response.json())
          .then((result) => resolve(result))
          .catch((error) => reject(error))
      })
    },
  }

  function validateEmail() {
    const emailInput = document.getElementById('ic-email')

    if (!emailInput.checkValidity()) {
      alert('Please enter a valid email address.')
      emailInput.focus()
      return false
    }
    return true
  }

  function handleResponse(event, form, buttonCliked) {
    event.preventDefault()
    if (!validateEmail()) {
      return
    }

    const isInsterested = buttonCliked === 'yes'
    const campaignName = form.dataset.campaign
    const surveyUrl = surveyURLs[campaignName][buttonCliked]

    const formData = new FormData(form)
    formData.append('is_interested', isInsterested)
    formData.append('campaign_name', campaignName)
    const data = JSON.stringify(Object.fromEntries(formData))

    const email = formData.get('email')

    request
      .post('interest-check/', data)
      .then((response) => {
        console.log(response)
        window.location = surveyUrl + '?email=' + email
      })
      .catch((error) => {
        console.log(error)
        window.location = surveyUrl + '?email=' + email
      })
  }

  const form = document.getElementById('ic-form')
  const buttonYes = document.getElementById('ic-button-yes')
  const buttonNo = document.getElementById('ic-button-no')

  // Get "email" from query string and populate the email field.
  const urlParams = new URLSearchParams(window.location.search)
  const email = urlParams.get('email')
  if (email) {
    const emailInput = document.getElementById('ic-email')
    emailInput.value = email
  }

  buttonYes.addEventListener('click', function (event) {
    handleResponse(event, form, 'yes')
  })

  buttonNo.addEventListener('click', function (event) {
    handleResponse(event, form, 'no')
  })
}
